import store from './main.js';
import './hooks/offers.js';
import './hooks/auth.js';
import './hooks/events.js';
import './hooks/request.js';
import './hooks/language.js';

export default store;
